/* eslint-disable */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalVideoLlamada.css';
import generateAbsoluteUrl from '../../../utils/generateAbsoluteUrl';
import * as telemedicinaAction from '../../../actions/telemedicinaActions';
import TimerModalVideoLlamada from './TimerModalVideoLlamada/TimerModalVideoLlamada';
import FooterModalVideoLlamada from './FooterModalVideoLlamada/FooterModalVideoLlamada';
import UploadsModalVideoLlamada from './UploadsModalVideoLlamada/UploadsModalVideoLlamada';
import UploadsOkModalVideoLlamada from './UploadsOkModalVideoLlamada/UploadsOkModalVideoLlamada';
import HideModalVideoLlamada from './HideModalVideoLlamada/HideModalVideoLlamada';
import { LOCALSTORAGE_AUTH_KEY } from '../../../constants/index';
import audioSwiss from '../../../../public/images/360831__tec-studios__fantasy-sfx-002.wav';
//import MonitoringUtil from '../../../utils/monitoringUtil.js';

class ModalVideoLlamada extends React.Component {
  constructor(props) {
    super(props);

    this.grtcClient = null;
    this.grtcSession = null;
    this.localID = '';
    this.remoteID = '';
    this.remoteStatusMsg = '';
    this.remoteViewFactor = 1;
    this.newSessionOnNewOffer = false;

    //Monitoring log
    //this.monitoringUtil = new MonitoringUtil();    

    this.state = {
      fullScreenClass: '',
      timeOut: '',
      loading: false,
      files: [],
      detalle: '',
      token: '',
    };

    this.hideModalVideoLlamada = this.hideModalVideoLlamada.bind(this);
    this.handleLeavePage = this.handleLeavePage.bind(this);
    this.hideFooter = this.hideFooter.bind(this);
    this.maximizeModalVideoLlamada = this.maximizeModalVideoLlamada.bind(this);
    this.exitHandler = this.exitHandler.bind(this);
    this.toggleMaximize = this.toggleMaximize.bind(this);
    this.restoreModalVideoLlamada = this.restoreModalVideoLlamada.bind(this);
    this.getPhoto = this.getPhoto.bind(this);
    this.cancelUpload = this.cancelUpload.bind(this);
    this.retryUpload = this.retryUpload.bind(this);
    this.disconnect = this.disconnect.bind(this);
    this.isWellTest = this.isWellTest.bind(this);

    this.stopInterval = false;
  }

  crearCliente(clientId, alertaSonora, dataToken) {

    if(this.grtcClient){
      console.log("INICIO CREAR CLIENTE");
      this.grtcClient.setLogLevel(4);
      this.newSessionOnNewOffer = Grtc.getWebrtcDetectedBrowser() === 'firefox';
      this.grtcClient.setRenewSessionOnNeed(false);
      this.grtcClient.setMediaConstraintsForOffer(true, true);
      this.grtcClient.setMediaConstraintsForAnswer(true, true);
      this.grtcClient.setVideoBandwidth(500);

      this.grtcClient.filterIceCandidates = function(Candidates) {
        const outCandidates = [];
        const count = Candidates.length;
        for (let i = 0; i < count; i++) {
          const strCandidate = JSON.stringify(Candidates[i]);
          if (
            strCandidate.match(/ 192\.168\.\d{1,3}\.\d{1,3} \d+ typ host/i) ===
              null &&
            strCandidate.match(/ tcp \d+/i) === null
          ) {
            outCandidates.push(Candidates[i]);
          }
        }
        return outCandidates;
      };

      this.grtcSession = new Grtc.MediaSession(this.grtcClient);
      this.grtcSession.onRemoteStream.add(this.updateRemoteStatus);
      this.grtcSession.onRemoteStream.add(this.attachRemoteStream);

      this.grtcSession.onSessionHold.add(isTrue => {
        if (isTrue) {
          console.log('Call on-hold');
          $('#remoteStatus').text(`${this.remoteStatusMsg} - on-hold`);
        }
      });

      this.grtcClient.onIncomingCall.add(data => {
        this.grtcSession = new Grtc.MediaSession(this.grtcClient);
        this.grtcSession.onRemoteStream.add(data2 => {
          this.grtcClient.setViewFromStream(
            document.getElementById('remoteView'),
            data2.stream,
          );
        });
        this.remoteID = data.peer;

        const user_said = window.confirm(
          `Desea recibir la llamada de ${data.peer}?`,
        );
        if (user_said === true) {
          $('#remoteStatus').empty();
          $('#remoteStatus').append(`call from ${this.remoteID}`);
          this.grtcSession.acceptCall(true, true, this.remoteID);
        } else {
          this.grtcSession.rejectCall();
          this.grtcSession = null;
        }
        return false;
      });

      this.grtcClient.onCallEvent.add(data => {
        console.log(`Call event: ${data.event}`);

      if(data.event === 'answer sent'){
        this.stopInterval = true;
        
        //Monitoring log
        //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onCallEvent", message:"El usuario INICIA video llamada." });  

        $(`#hideModal`).show();
        $('#videoSwiss').each(function() {
          $(this)[0].pause();
        });
        
        if (alertaSonora) {
          setTimeout(() => {
            $('#audioSwiss').trigger('play');
          }, 500);
        }
        $('#divVideoSwiss').hide();
        $('#divRemote').show();
      
      }
        return false;
      });

      this.grtcClient.onNotifyEvent.add(data => {
        console.log('onNotifyEvent');
        if (this.remoteID === '') {
          this.remoteID = data.peer;
          this.remoteStatusMsg = `Call from ${this.remoteID}`;
        }
        $('#remoteStatus').empty();
        if (data.event === 'talk') {
          $('#remoteStatus').append(`${this.remoteStatusMsg} - established`);
        } else if (data.event === 'hold') {
          $('#remoteStatus').append(`${this.remoteStatusMsg} - on-hold`);
        }
        return false;
      });

      // Invoked when info data arrives from the peer.
      this.grtcClient.onInfoFromPeer.add(data => {
        console.log('onInfoFromPeer');
        alert(`Got data from peer:\n${JSON.stringify(data)}`);
        return false;
      });

      this.grtcClient.onIceDisconnected.add(() => {
        console.log('onIceDisconnected');
        if (this.grtcSession) {
          this.grtcSession.makeOffer();
        }
        return false;
      });

      this.grtcClient.onConnectionError.add(() => {
        console.log('onConnectionError');
        return false;
      });

      this.grtcClient.onGatewayError.add(() => {
        console.log('onGatewayError');
      });

      // Invoked on WebRTC browser API error, which could be recoverable.
      // The app may want to ignore this error, log it, and/or inform the user.
      this.grtcClient.onWebrtcError.add(obj => {
        console.log('onConnectionError');
        alert(`Got WebRTC error: ${JSON.stringify(obj)}`);
        return false;
      });

      // When the peer closes, this event is fired; do the necessary clean-up here.
      this.grtcClient.onPeerClosing.add(() => {
        console.log('onPeerClosing');
        this.stopInterval = true;
        console.log('disconnect from onPeerClosing');
        this.disconnect();
        this.cleanupAfterCall();

        //Monitoring log
        //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onPeerClosing", message:"El usuario se fue de la video llamada." });  
        
        $('#modalFinalizado').modal({ backdrop: 'static', keyboard: false });
        return false;
      });

      // Fired on no-answer timeout after making an initial or updated offer to peer.
      this.grtcClient.onPeerNoanswer.add(() => {
        console.log('onPeerNoanswer');
        if (this.grtcSession) {
          this.grtcSession.closeSession(true);
        }
        //Monitoring log
        //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onPeerNoAnswer", message:"El usuario no fue atendido en la llamada." });  
        
        this.cleanupAfterCall();
        return false;
      });

      /* Carga de medios exitosa */
      this.grtcClient.onMediaSuccess.add(obj => {
        console.log('onMediaSuccess');
        if(document.getElementById('localView')){
          document.getElementById('localView').style.opacity = 1;
          this.grtcClient.setViewFromStream(
            document.getElementById('localView'),
            obj.stream,
          );
      
          /* Apertura de stream remoto */
          this.grtcSession.onRemoteStream.add(obj => {
            console.log('onRemoteStream');
            this.grtcClient.setViewFromStream(
              document.getElementById('remoteView'),
              obj.stream,
            );
          });
        }
        return false;
      });

      /* Falla carga de medios */
      this.grtcClient.onMediaFailure.add(obj => {
        console.log('onMediaFailure');
        // $('#modalUserMediaError').modal('show');
        this.props.setHasMediaError(true);
        return false;
      });

      /* Callback cuando hay conexion */
      this.grtcClient.onConnect.add(() => {
        console.log('handleOnConnect');
        $('#localStatus').empty();
        $('#localStatus').append('Registered anonymously');
        return false;
      });

      /* Callback register */
      this.grtcClient.onRegister.add(() => {
        console.log('handleOnRegister');
        $('#localStatus').empty();
        $('#localStatus').append(`Registered as ${this.localID}`);

        console.log('Hacer llamada');

        this.hacerLlamada(this.state.token, this.props.direccion);

        //Monitoring log
        //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - onRegister", message:"El usuario realizo la registracion en GRTC de manera exitosa." });  

        return false;
      });

      /* Callback falla */
      this.grtcClient.onFailed.add(obj => {
        console.log('handleOnConnectFailed');
        alert(obj.message);
        this.localID = '';
        
        return false;
      });

      this.habilitarMedios(clientId, dataToken);
    }
  }

  habilitarMedios(clientId, dataToken) {
    console.log("INICIO HABILITAR MEDIOS");
    if (!this.grtcClient) {
      alert('Grtc.Client instance not created');
    } else {
      this.grtcClient.enableMediaSource(true, {mandatory:{minAspectRatio: 1.777, maxAspectRatio: 1.777}});
    }

    this.register(clientId, dataToken);
  }

  register(clientId, dataToken) {
    console.log("INICIO REGISTER");
    const registerID = clientId;
    
    const datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    const contra = datos.modelEspecifico.contra;
    const inte = datos.modelEspecifico.inte;

    this.grtcClient.register(registerID, { dnPaciente: clientId, data: dataToken });
    this.grtcSession = new Grtc.MediaSession(this.grtcClient);
    this.grtcSession.onRemoteStream.add(data2 => {
      this.grtcClient.setViewFromStream(
        document.getElementById('remoteView'),
        data2.stream,
      );
    });
  }

  isWellTest = (turno) => {
    return turno.titular.prestador === "359" ||
    turno.titular.prestador === "525" ||
    turno.titular.prestador === "36360" ||
    turno.titular.prestador === "349";
  }


  hacerLlamada(token, direccion) {
    console.log("INICIO HACER LLAMADA"); 
    const enviroment = generateAbsoluteUrl(); 
    //QA = php02
    //INT = php01
    this.remoteID = this.props.turno.tipo == 'E' ?  6097 : (this.isWellTest(this.props.turno) ? 6099 : 6098);
    if(enviroment.includes("localhost") || enviroment.includes("pre") ||  enviroment.includes("clubswiss")){
      if(this.props.turno.tipo == 'E') {
        this.remoteID = 609701
      }else if(this.isWellTest(this.props.turno)) {
        this.remoteID = 6095;
      }else{
        this.remoteID = 609801;
      }
    }else if(enviroment.includes("int") || enviroment.includes("srv-php01")){
      this.remoteID = this.props.turno.tipo == 'E' ?  609702 : 609802;
    }else if(enviroment.includes("srv-php02") || enviroment.includes("qa")){
      this.remoteID = this.props.turno.tipo == 'E' ?  609703 : 609803;
    }

    $('#remoteStatus').empty();
    this.remoteStatusMsg = `Call to ${this.remoteID}`;
    $('#remoteStatus').append(this.remoteStatusMsg);

    let datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
    let datosInteSelected = JSON.parse(localStorage.getItem('inteSelected'));
    const contra = datos.modelEspecifico.contra;
    const inte = datosInteSelected.inte;

    const json = {
      contra,
      inte,
      domicilio: direccion,
    };

    let dataToAttach = [
      {
        key: 'plain',
        value: json,
      },
      {
        key: 'encrypted',
        value: token.encrypted,
      },
    ];

    this.grtcSession.setData(dataToAttach);
    this.grtcSession.makeOffer(this.remoteID, true, true);
    this.grtcSession.onstablestate();
    console.log("FIN HACER LLAMADA");
  }

  disconnect(){
    this.grtcClient.disconnect();
  }

  updateRemoteStatus() {
    if (useTalkEvent === false) {
      $('#remoteStatus').empty();
      if (this.remoteID !== '') {
        // A BYE could close session before we get here.
        $('#remoteStatus').append(`${this.remoteStatusMsg} - established`);
      }
    }
    return true;
  }

  attachRemoteStream(data) {
    const element = document.getElementById('remoteView');
    if (element.getAttribute('src') === null) {
      console.log('Attaching remote stream');
    } else {
      console.log('Reattaching remote stream');
    }
    this.grtcClient.setViewFromStream(element, data.stream);
    return false;
  }

  cleanupAfterCall() {
    this.savedStats = null;
    $('#remoteStatus').empty();
    this.remoteID = '';
    this.remoteStatusMsg = '';
  }

  hideModalVideoLlamada() {
    this.restoreModalVideoLlamada();
    $('#modalConsultaSinFinalizar').modal('show');
  }

  componentDidMount() {
    if(this.props.IniciarLlamada == 0){
      //renovar token cada 10 minutos
      setInterval(function(){ 
        //let datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
        let token = JSON.parse(localStorage.getItem("token"));
        let dataToken = {
          token,
        };
        $.ajax({
          url: `${generateAbsoluteUrl()}/renew-token`,
          global: false,
          type: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(dataToken),
          async: true, 
          success: function(response)  {
            if (response.data && response.data.token && response.data.exp) {
              let authData = localStorage.getItem(LOCALSTORAGE_AUTH_KEY);
              let authJson = JSON.parse(authData);
              authJson.token = response.data.token;
              authJson.exp = response.data.exp;    
              if(authJson){
                localStorage.removeItem(LOCALSTORAGE_AUTH_KEY);
                localStorage.removeItem('token');
                localStorage.setItem('token', JSON.stringify(authJson.token));
                localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(authJson));
              }
            }
          }
        });
      }, 1000 * 60 * 15);
       // fin renovar token cada 5 minutos
    }
    this.grtcClient = null;
    this.grtcSession = null;
    this.localID = '';
    this.remoteID = '';
    this.remoteStatusMsg = '';
    this.remoteViewFactor = 1;
    this.newSessionOnNewOffer = false;
    const configuration = {
      webrtc_gateway: 'https://wrtc-arg.crossnet.la:443',
      turn_server: 'stun-arg.crossnet.la:443?transport=tcp',
      turn_username: 'genesys',
      turn_password: 'genesys',
      noanswer_timeout: 7200000
    };
    this.grtcClient = new Grtc.Client(configuration);
    window.addEventListener('beforeunload', this.handleLeavePage);
    document.addEventListener('fullscreenchange', this.exitHandler);
    document.addEventListener('webkitfullscreenchange', this.exitHandler);
    document.addEventListener('mozfullscreenchange', this.exitHandler);
    document.addEventListener('MSFullscreenChange', this.exitHandler);

    $('#modalVideoLlamada').fadeIn(200);

    $(`#iframe_llamada`).mousemove(() => {
      if ($(`#modalVideoLlamada`).hasClass(s.full)) {
        if (!$(`#modalVideoLlamadaFooter.${s.full}`).is(':visible')) {
          $(
            `#modalVideoLlamadaFooter.${s.full}, #modalVideoLlamadaheader.${s.full}`,
          ).slideToggle(100);
        }
        clearTimeout(this.state.timeOut);
        this.hideFooter();
      }
    });

    $('#modalVideoLlamadaFooter').mouseenter(() => {
      clearTimeout(this.state.timeOut);
    });
    
  }

  componentWillReceiveProps(props) {
    if (props.IniciarLlamada == 1) {
      let datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
      const datosInteSelected = JSON.parse(
        localStorage.getItem('inteSelected'),
      );
      let token = datos.token;
      const inte = datosInteSelected.inte;

      const objInte = this.props.integrante.filter(
        element => element.inte == inte,
      );

      let dataToken = {
        token,
        json: this.generarJsonTurno(this.props.turno, objInte[0]),
      };
      fetch(`${generateAbsoluteUrl()}/api/generarTokenLlamada`, {
        method: 'POST',
        body: JSON.stringify(dataToken),
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      })
        .then(res => res.json())
        .then(response => {
          const contra = datos.modelEspecifico.contra;
          const inte = datos.modelEspecifico.inte;

          //Monitoring log
          //this.monitoringUtil.createAffilliateLog({ interaction:"GRTC - GENERACION TOKEN", message:"Se genera el token de la video llamada." });  
          
          this.setState({ token: response });
          this.crearCliente(
            this.props.clientId,
            this.props.alerta_sonora,
            dataToken
          );
        });
    }
  }

  componentWillUnmount() {
    this.props.cleanTurnoTomado();
    this.props.cleanAdmision();
    this.props.cleanDomicilio();
    console.log('disconnect from willUnMount');
    this.grtcClient.disconnect();
    this.grtcClient = null;
    this.grtcSession = null;
    this.localID = '';
    this.remoteID = '';
    this.remoteStatusMsg = '';
    this.remoteViewFactor = 1;
    this.newSessionOnNewOffer = false;
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  generarJsonTurno(turno, afiliado) {
    const objAfiliado = {
      afiliado: { afiliado },
    };

    const objTurno = {
      turno: { turno },
    };
    const turnoCompleto = $.extend(objTurno.turno, objAfiliado.afiliado);
    return turnoCompleto;
  }

  getPhoto(e) {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    $('#modalVideoLlamadaUploads').show(200);
    $('#estudiosIcon').popover('hide');

    const file = e.target.files[0];
    let progress = 0;

    if (file) {
      const extension = file.name.split('.').pop().toLowerCase();
      const fileTypes = ['jpg', 'jpeg', 'png', 'pdf'];
      const fileTypeSuccess = fileTypes.indexOf(extension) > -1;
      const fileSizeSuccess = file.size < 10485760;

      if (fileTypeSuccess && fileSizeSuccess) {
        const reader = new FileReader();
        reader.onprogress = data => {
          if (data.lengthComputable) {
            $('#modalVideoLlamadaUploadsOk').hide(200);
            progress = parseInt(data.loaded / data.total * 100, 10);

            if (progress < 100) {
              $('#modalVideoLlamadaUploads').show(200);
              this.setState({
                loading: true,
              });
            }

            const fileAdded = {
              file,
              progress,
              reader,
              motivo: '',
            };

            const filesAddedState = this.state.files;
            filesAddedState[fileAdded.file.name] = fileAdded;

            this.setState({
              files: filesAddedState,
            });
          }
        };

        reader.onloadend = () => {
          const filesAddedState = this.state.files;
          const fileInState = filesAddedState[file.name];

          if (
            fileInState.progress == 100 &&
            fileInState.progress !== 'Cancelado'
          ) {
            
            const fileAdded = {
              file,
              progress: 'cargando',
              motivo: '',
              reader: null,
            };
            const filesAddedState = this.state.files;
            filesAddedState[fileAdded.file.name] = fileAdded;
            this.setState({ files: filesAddedState, loading: true });

            const medico = this.props.turno.prestador;
            let content = reader.result;
           
            content = content.replace('data:image/png;base64,', '');
            content = content.replace('data:application/pdf;base64,', '');
            content = content.replace('data:image/jpg;base64,', '');
            content = content.replace('data:image/jpeg;base64,', '');

            let datos = JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
            let token = datos.token;
  
            let dataUpload = {
              token,
              paciente: `${datos.modelEspecifico.apellido} ${datos.modelEspecifico.nombre}`,
              filename: file.name,
              content,
              medico,
            };
            // this.props.uploadFilesTelemedicina(file.name, content, medico);
            fetch(`${generateAbsoluteUrl()}/api/fileUploadModalVideollamada`, {
              method: 'POST',
              body: JSON.stringify(dataUpload),
              headers: new Headers({
                'Content-Type': 'application/json',
              }),
            })
              .then(res => res.json())
              .then(response => {
                if (response.directory) {
                  const fileAdded = {
                    file,
                    progress: 'ok',
                    motivo: '',
                    reader: null,
                  };
                  const filesAddedState = this.state.files;
                  filesAddedState[fileAdded.file.name] = fileAdded;
                  this.setState({ files: filesAddedState, loading: true });
                  $('#modalVideoLlamadaUploads').hide(200);
                  $('#modalVideoLlamadaUploadsOk').show(200);
                  setTimeout(() => {
                    $('#boton_cerrar').click();
                  }, 2000);
                } else {
                  const fileAdded = {
                    file,
                    progress: 'Cancelado',
                    motivo: 'Error al subir',
                    reader: null,
                  };
                  const filesAddedState = this.state.files;
                  filesAddedState[fileAdded.file.name] = fileAdded;
                  this.setState({ files: filesAddedState, loading: true });
                  $('#modalVideoLlamadaUploadsOk').hide(200);
                }
              });
          }
        };

        if (file) {
          reader.readAsDataURL(file);
        }
      } else if (!fileTypeSuccess) {
        // error de extension
        const fileAdded = {
          file,
          progress: 'Cancelado',
          motivo: 'Extensión no válida',
          reader: null,
        };

        const filesAddedState = this.state.files;
        filesAddedState[fileAdded.file.name] = fileAdded;
        this.setState({ files: filesAddedState, loading: true });
        $('#modalVideoLlamadaUploadsOk').hide(200);
      } else {
        // error de tamanio
        const fileAdded = {
          file,
          progress: 'Cancelado',
          motivo: 'Peso excedido',
          reader: null,
        };

        const filesAddedState = this.state.files;
        filesAddedState[fileAdded.file.name] = fileAdded;
        this.setState({ files: filesAddedState, loading: true });
        $('#modalVideoLlamadaUploadsOk').hide(200);
      }
    } else {
      this.setState({ loading: true });
      $('#modalVideoLlamadaUploadsOk, #modalVideoLlamadaUploads').hide(200);
    }
  }

  maximizeModalVideoLlamada() {
    $('#medico_nombre').show();
    $('#divInputVolume').hide();
    $('#divEstudios').hide();

    if($("#divVideoSwiss").is(":visible")){

      const elem = document.getElementById('videoSwiss');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
      $(`#modalVideoLlamadaheader`).show(); // , #modalVideoLlamadaEnd
      // this.hideFooter();
    }
    else{
            //$('#localView').hide();
      //$("#elemento").is(":visible");
      $('#modalVideoLlamada').css({
        width: '100%',
        height: '100%',
        left: '0',
        top: '0',
        padding: '0',
        border: '0',
      });

      $('#divLlamada').css({
        padding: '0',
      });

      this.setState({
        fullScreenClass: s.full,
      });

      $('#texto_modal_videollamada').hide();
      $('#iframe_llamada').width('100%');
      $('#iframe_llamada').removeClass('col-8');
      $('#iframe_llamada').addClass('col-12');
      $('#divRemoteVideo').removeClass('col-10');
      $('#divRemoteVideo').addClass('col-12');

      // Cambiar color de iconos
      $('#modalMaximize').hide();
      $('#modalRestore').show();

      $('#VolumeIcon').hide();
      $('#VolumeIconWhite').show();

      $('#modalClip').hide();
      $('#modalClipWhite').show();

      $('#estudiosIcon').hide();
      $('#estudiosIconWhite').show();
      const elem = document.getElementById('modalVideoLlamada');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
      $(`#modalVideoLlamadaheader`).show(); // , #modalVideoLlamadaEnd
       //this.hideFooter();
    }
  }

  restoreModalVideoLlamada() {
     $('#medico_nombre').hide();
     $('#divInputVolume').hide();
     $('#divEstudios').hide();

     // Cambiar color de iconos
     $('#modalRestore').hide();
     $('#modalMaximize').show();
 
     $('#VolumeIconWhite').hide();
     $('#VolumeIcon').show();
 
     $('#modalClipWhite').hide();
     $('#modalClip').show();
 
     $('#estudiosIconWhite').hide();
     $('#estudiosIcon').show();

    // Si esta en full screen la saca
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }

    if($("#divVideoSwiss").is(":visible")){
      $(`#hideModal`).hide();
 
    }
    else{
      $('#divLlamada').css({
        padding: '10px',
      });

      this.setState({
        fullScreenClass: '',
      });

      $('#modalVideoLlamada').css({
        width: '98%',
        height: '80%',
        left: '20px',
        top: '70px',
        padding: '0',
        border: '0',
        padding: '10px 10px 68px',
      });
  
    }

    $(`#modalVideoLlamadaheader`).hide(); // , ##modalVideoLlamadaEnd
  }

  toggleMaximize() {
    $('#divInputVolume').hide();
    $('#divEstudios').hide();
    if($("#divVideoSwiss").is(":visible")){
      $(`#hideModal`).hide();
    }
    if (
      !document.fullscreenElement && // alternative standard method
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      this.maximizeModalVideoLlamada();
    } else {
      this.restoreModalVideoLlamada();
    }
  }

  exitHandler() {
    $('#divInputVolume').hide();
    $('#divEstudios').hide();
    if($("#divVideoSwiss").is(":visible")){
      $(`#hideModal`).hide();
    }

    if (
      !document.fullscreenElement &&
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      $('#modalVideoLlamada').css({
        width: '98%',
        height: '80%',
        top: '60px',
        //right: '60px',
        padding: '10px 10px 68px 10px',
        border: '1px solid #ccc',
      });

      $('#divLlamada').css({
        padding: '10px',
      });

      // Cambiar color de iconos
     $('#modalRestore').hide();
     $('#modalMaximize').show();
 
     $('#VolumeIconWhite').hide();
     $('#VolumeIcon').show();
 
     $('#modalClipWhite').hide();
     $('#modalClip').show();
 
     $('#estudiosIconWhite').hide();
     $('#estudiosIcon').show();


     /* $('#texto_modal_videollamada').show();
      $('#iframe_llamada').width('60%');

      $('#modalRestore').hide();
      $('#modalMaximize').show();*/

      this.setState({
        fullScreenClass: '',
      });
      $(`#modalVideoLlamadaFooter`).show();
      $(`#modalVideoLlamadaheader`).hide(); // , #modalVideoLlamadaEnd
    }
  }

  hideFooter() {
    this.setState({
      timeOut: setTimeout(() => {
        $(
          `#modalVideoLlamadaFooter.${s.full}, #modalVideoLlamadaheader.${s.full}`, // #modalVideoLlamadaEnd.${s.full}
        ).fadeOut(1000, () => {
          if (!$('#modalVideoLlamadaFooter').hasClass(s.full)) {
            $(`#modalVideoLlamadaFooter`).show();
          }
        });
      }, 2000),
    });
  }

  handleLeavePage(e) {
    const confirmationMessage =
      'Aún no finalizaste la E-Consulta ¿Querés salir sin terminarla?';
    e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
    return confirmationMessage; // Gecko, WebKit, Chrome <34
  }

  cancelUpload(key) {
    const filesAddedState = this.state.files;
    const stateFile = filesAddedState[key];
    stateFile.reader.abort();
    stateFile.progress = 'Cancelado';
    stateFile.motivo = 'Cancelado';
    filesAddedState[key] = stateFile;
    this.setState({ files: filesAddedState, loading: true });
  }

  retryUpload(key) {
    const filesAddedState = this.state.files;
    const stateFile = filesAddedState[key];

    if (stateFile.file) {
      stateFile.reader.readAsDataURL(stateFile.file);
    }

    filesAddedState[key] = stateFile;
    this.setState({ files: filesAddedState, loading: true });
  }

  render() {
    if(this.props.espontaneo){
      this.props.turno.tipo = 'E'
    }

    const filesUploaded = this.state.files;     
    return (
     <div className={s.root}>
       <div id="divRemote">
         <div
          id="modalVideoLlamada"
          style={{display:'none'}}
          className={`${s.modalVideoLLamada} 
        ${this.state.fullScreenClass} divRemote`}
        >
          <div id="divLlamada" className="row" style={{height: '100%', padding: '10px' }}>
            <div
              style={{border: '5px solid', padding: '0', backgroundColor: '#000', height: 'inherit' }}
              id="divRemoteVideo"
              className="col-12"
              onDoubleClick={this.toggleMaximize}
            >
              <div id="medico_nombre" style={{ display: 'none' , marginTop: '45px', position: 'absolute' }} >
                <span style={{fontSize: '30px', marginLeft: '20px', color: '#fff', }} ><strong>Médico: {`${this.props.turno.titular.apeRazon} ${this.props.turno.titular.nombreAbre}`}</strong></span>
              </div>
              <audio id="audioSwiss">
                <source src={audioSwiss} type="audio/wav" />
              </audio>
              <video
                data-caption="1080 OGG"
                width="100%"
                height="90%"
                id="remoteView"
                //id="localView"
                className={`${s.modalRemoteView}`}
                autoPlay="autoplay">
              </video>
            <video
                className={`${s.modalLocalView}`}
                style={{ width: '15%', position: 'absolute', right: '0', bottom: '0' }}
                id="localView"
                autoPlay="autoplay"
                volume="0.5"
                muted="muted"/>
            </div>
          </div>
          <div
            className={`${s.modalVideoLlamadaheader} 
          ${this.state.fullScreenClass}`}
            id="modalVideoLlamadaheader"
          >
          </div>
          <div
            className={`${s.modalVideoLlamadaEnd} 
          ${this.state.fullScreenClass}`}
            id="modalVideoLlamadaEnd"
          >
            <i
              className="fa fa-phone"
              aria-hidden="true"
              onClick={this.hideModalVideoLlamada}
              role="button"
              tabIndex="-1"
            />
          </div>
          <div
            className={`${s.modalVideoLlamadaFooter} 
          ${this.state.fullScreenClass}`}
            id="modalVideoLlamadaFooter"
          >
            <FooterModalVideoLlamada
              maximizeModalVideoLlamada={this.maximizeModalVideoLlamada}
              restoreModalVideoLlamada={this.restoreModalVideoLlamada}
              getPhoto={this.getPhoto}
              llamadaIniciada={true}
            />
          </div>
          <UploadsModalVideoLlamada
            filesUploaded={filesUploaded}
            cancelUpload={this.cancelUpload}
            retryUpload={this.retryUpload}
          />
          <UploadsOkModalVideoLlamada />
          <div id="hideModal">
            <HideModalVideoLlamada llamadaIniciada={true} disconnect={this.disconnect} />
          </div>
        </div>
        </div>
        <div id="divVideoSwiss">
        <div
          id="modalVideoLlamada"
          className={`${s.modalVideoLLamada} 
    ${this.state.fullScreenClass} divVideoSwiss`}
        >
          <div className="row" style={{ height: '100%' }}>
            <div
              className="col-7"
              id="iframe_llamada"
              onDoubleClick={this.toggleMaximize}
            >
              <video
                loop="loop"
                width="100%"
                height="75%"
                autoPlay="autoplay"
                id="videoSwiss"
              >
              </video>
              <video
                style={{ width: '15%', position: 'absolute', right: '0', bottom: '0', display: 'none', paddingBottom: '3%'}}
                id="localView"
                autoPlay="autoplay"
                volume="0.5"
                muted="muted"
              />
            </div>
            <div
              className="col-5 d-flex align-items-center"
              style={{ paddingBottom: '72px' }}
            >
              <div id="texto_modal_videollamada" className="col-12 row">
                <TimerModalVideoLlamada turno={this.props.turno} stopInterval={this.stopInterval}/>
              </div>
            </div>
            <div
              className={`${s.modalVideoLlamadaFooter} 
          ${this.state.fullScreenClass}`}
              id="modalVideoLlamadaFooter"
            >
              <FooterModalVideoLlamada
                maximizeModalVideoLlamada={this.maximizeModalVideoLlamada}
                restoreModalVideoLlamada={this.restoreModalVideoLlamada}
                getPhoto={this.getPhoto}
                llamadaIniciada={false}
                fullScreen={this.state.fullScreenClass}
              />
            </div>
          </div>
          <HideModalVideoLlamada llamadaIniciada={false} disconnect={this.disconnect}/>
        </div>
     </div>
     </div>
    );
  }
}

const mapStateToProps = state => ({
  IniciarLlamada: state.telemedicina.iniciar_llamada,
  alerta_sonora: state.telemedicina.alerta_sonora,
  clientId: state.telemedicina.clientId,
  practica: state.telemedicina.practica,
  integrante: state.integrantes,
});

export default connect(mapStateToProps, telemedicinaAction)(
  withStyles(s)(ModalVideoLlamada),
);


// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalVideoLlamada/ModalVideoLlamada.js